import React from 'react'
import { Message } from 'semantic-ui-react'
import { __ } from '~/i18n'

//TODO: finish cart error boundary
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
  }

  render() {
    const { message } = this.props;
    if (this.state.hasError) {
      return (
        <Message warning>
          <p>{ message || __('Something went wrong')}</p>
        </Message>
      );
    }
    return this.props.children;
  }
}